export default {
  auth: 'AUTH',
  common: 'COMMON',
  dataValidation: 'DATA_VALIDATION',
};
